import React, { useEffect } from 'react'; // useEffect import kiya
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import AiHero from '../Components/Automation/AiHero';
import OurServiceOffer from '../Components/Automation/OurServiceOffer';
import AccContact from '../Components/Accelerating/AccContact';
import { industriesData } from '../data/industriesData';
import OurServices from '../Components/home/OurServices';
import Banner from '../Components/Banner';
import ContactSection from '../Components/home/ContactSection';


function HealthcareIndustryDetail() {


    const { id } = useParams();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [id]);

    const currentIndustry =
        Object.values(industriesData).find((item) => item.id === id) ||
        industriesData.healthcare;

    if (!currentIndustry) {
        return (
            <div className="flex justify-center items-center h-screen text-2xl font-bold text-gray-600">
                Industry Not Found
            </div>
        );
    }

    const industryName = currentIndustry.title;

    const industrySlug = industryName
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');


    return (
        <div>

            <Helmet>
                <title>
                    {industryName} Industry Solutions | Enterprise AI & ServiceNow Consulting | Mobikode
                </title>

                <meta
                    name="description"
                    content={`Mobikode delivers ${industryName} industry solutions designed to streamline operations, automate workflows, improve efficiency, and accelerate Enterprise AI & ServiceNow Consulting with scalable technology solutions.`}
                />

                <meta
                    name="keywords"
                    content={`${industryName} Solutions, ${industryName} Technology Solutions, ${industryName} Enterprise AI & ServiceNow Consulting, ${industryName} Software Solutions, ${industryName} IT Services, ${industryName} Automation Solutions, ${industryName} Consulting Services, ${industryName} Application Development, ${industryName} Digital Solutions`}
                />

                <link
                    rel="canonical"
                    href={`https://www.mobikode.com/industries/${id}`}
                />

                <meta
                    property="og:title"
                    content={`${industryName} Industry Solutions | Mobikode`}
                />

                <meta
                    property="og:description"
                    content={`Explore Mobikode's ${industryName} industry solutions for smarter operations, workflow automation, Enterprise AI & ServiceNow Consulting, and scalable technology innovation.`}
                />

                <meta
                    property="og:url"
                    content={`https://www.mobikode.com/industries/${id}`}
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content={`https://www.mobikode.com/${currentIndustry.heroImg?.replace(/^\/+/, '')}`}
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content={`${industryName} Industry Solutions | Mobikode`}
                />

                <meta
                    name="twitter:description"
                    content={`Discover Mobikode's ${industryName} technology solutions for automation, Enterprise AI & ServiceNow Consulting, application development, and improved business operations.`}
                />

                <meta
                    name="twitter:image"
                    content={`https://www.mobikode.com/${currentIndustry.heroImg?.replace(/^\/+/, '')}`}
                />
            </Helmet>
            <AiHero
                title={currentIndustry.title}
                imgData={currentIndustry.heroImg}
            />

            <section className="w-full py-[50px] lg:py-[80px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row h-auto lg:h-[323px] group">

                        <div className="overflow-hidden w-full lg:max-w-[624px] h-[250px] lg:h-full relative z-10">
                            <img
                                src={currentIndustry.overviewImg}
                                alt={currentIndustry.overviewTitle}
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>

                        <div className="relative z-20 w-full flex justify-center items-center lg:max-w-[656px] bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] 
                            px-[20px] py-[30px] lg:px-[40px] lg:py-[30px] 
                            -mt-6 lg:mt-0 lg:ml-0 group">
                            <div className="w-full">
                                <h3 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] mb-[15px]">
                                    {currentIndustry.overviewTitle}
                                </h3>
                                <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-graphik font-[500] text-justify">
                                    {currentIndustry.overviewText}
                                </p>
                            </div>

                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>
                        </div>
                    </div>
                </div>
            </section>

            <OurServices service={currentIndustry.solutions} />
            {/* <OurServiceOffer service={currentIndustry.solutions} /> */}

            {/* <section className='relative'>
                <img src="/assets/product/bg1.jpg" className='lg:h-[683px] h-[800px] w-full object-cover' alt="Contact background" />
                <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px] top-1/2 -translate-y-1/2 absolute left-1/2 -translate-x-1/2">
                    <AccContact />
                </div>
            </section> */}
            <Banner title={currentIndustry.title} />
            <ContactSection/>
        </div>
    );
}

export default HealthcareIndustryDetail;